import { FC, useEffect } from 'react';
import {
  FabricJSCanvas,
  useEditorData,
  useFabricEditor,
} from '../lib/FabricJs';
import { RealSize } from '../types';
import styled from 'styled-components';
import SpacePan from './SpacePan';
import { Ruler, RulerCorner, RULER_SIZE } from './Rulers';

const Workspace = styled.div<{ rulers: boolean }>`
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: ${({ rulers }) =>
    rulers ? `${RULER_SIZE}px minmax(0, 1fr)` : 'minmax(0, 1fr)'};
  grid-template-rows: ${({ rulers }) =>
    rulers ? `${RULER_SIZE}px minmax(0, 1fr)` : 'minmax(0, 1fr)'};
`;

const Viewport = styled.div`
  position: relative;
  min-width: 0;
  min-height: 0;
`;

type CanvasBodyProps = RealSize;

const CanvasBody: FC<CanvasBodyProps> = ({ realHeight, realWidth }) => {
  const { editor, canvas, onReady } = useFabricEditor();
  const { showRulers } = useEditorData();
  useEffect(() => {
    if (canvas && !canvas?.backgroundColor) {
      canvas.setBackgroundColor('white', () => {});
      canvas.requestRenderAll();
    }
  }, [editor]);

  return (
    <Workspace rulers={showRulers}>
      {showRulers && (
        <>
          <RulerCorner />
          <Ruler orientation="horizontal" />
          <Ruler orientation="vertical" />
        </>
      )}
      <Viewport>
        <FabricJSCanvas
          onReady={onReady}
          realHeight={realHeight}
          realWidth={realWidth}
        />
        <SpacePan />
      </Viewport>
    </Workspace>
  );
};

export default CanvasBody;
